/**
 * Shared date/formatting utilities.
 */

/** Format a date as "15 Mar 2026". Returns "—" for null/undefined. */
export function formatDate(date) {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
